import { ImageSearchResult } from '../api'

interface ImageSelectorProps {
  images: ImageSearchResult[]
  selectedIndex: number | null
  onSelect: (index: number) => void
  isLoading: boolean
}

export function ImageSelector({
  images,
  selectedIndex,
  onSelect,
  isLoading
}: ImageSelectorProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-base sm:text-xl font-bold text-[#414142] dark:text-[#D9D9D9]">Escolha uma imagem</h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3">
        {images.map((image, index) => (
          <div
            key={index}
            onClick={() => !isLoading && onSelect(index)}
            className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition sm:hover:scale-105 ${
              selectedIndex === index
                ? 'border-[#414142] dark:border-[#D9D9D9] ring-2 ring-[#414142]/30 dark:ring-[#D9D9D9]/30'
                : 'border-gray-300 dark:border-[#5A5A5E] hover:border-[#414142] dark:hover:border-[#D9D9D9]'
            } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="aspect-square bg-gray-100 dark:bg-[#232326] flex items-center justify-center overflow-hidden relative">
              <img
                src={image.thumbnailUrl}
                alt={image.title || `Imagem ${index + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect fill=%22%23f3f4f6%22 width=%22100%22 height=%22100%22/%3E%3C/svg%3E'
                }}
              />
              <div className="absolute bottom-1 left-1 right-1 pointer-events-none flex justify-start">
                <span className="inline-block max-w-full truncate rounded bg-black/45 px-1.5 py-0.5 text-[8px] sm:text-[9px] text-white shadow-[0_1px_4px_rgba(0,0,0,0.65)] backdrop-blur-[1px]">
                  {image.domain || (() => {
                    try { return new URL(image.sourceUrl || image.imageUrl).hostname.replace(/^www\./, '') } catch { return 'origem desconhecida' }
                  })()}
                </span>
              </div>
            </div>


            {selectedIndex === index && (
              <div className="absolute top-1 right-1 bg-[#414142] dark:bg-[#D9D9D9] text-white dark:text-[#18181A] rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold">
                ✓
              </div>
            )}
          </div>
        ))}
      </div>

      {images.length > 0 && selectedIndex !== null && (
        <div className="mt-2 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
          <p className="text-sm text-green-800 dark:text-green-300 font-semibold">✓ Imagem {selectedIndex + 1} selecionada</p>
        </div>
      )}
    </div>
  )
}
